import React from 'react';
import { FormatDateTime } from 'js/common/components/FormatDateTime';
import Buttom from '@leafygreen-ui/button';
import { palette } from '@leafygreen-ui/palette';

interface DeviceAuthConfirmationProps {
  sourceUserAgent: string;
  sourceIp: string;
  onConfirm: () => void;
  onBack: () => void;
  createdAt: Date | string;
}

export function DeviceAuthConfirmation({
  sourceIp,
  sourceUserAgent,
  createdAt,
  onConfirm,
  onBack,
}: DeviceAuthConfirmationProps) {
  return (
    <>
      <p>MongoDB CLI is trying to access your account.</p>
      <p css={{ color: palette.gray.dark1 }}>
        Requested from {sourceIp} ({sourceUserAgent}) on <FormatDateTime isoString={createdAt} />
      </p>
      <div css={{ marginTop: 30 }}>
        <Buttom css={{ marginRight: 20 }} variant="primary" onClick={onConfirm} name="confirm">
          Confirm Authorization
        </Buttom>
        <Buttom onClick={onBack} name="back">
          Back
        </Buttom>
      </div>
    </>
  );
}
